import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from "react";

import { serverHost } from "../../../http_common.js";
import PurchaseOrdersPreview from "../clients-account-comps/inventory_comps/previews/PreviewPurchseOrders.jsx";
import ExportPDFButton from "../clients-account-comps/inventory_comps/exports/OrdersPDFExport.jsx";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import ReactQuill from "react-quill";
import { useReactToPrint } from "react-to-print";

import * as Action from "../../../store/redux/orders_reducers.js";
import { onchangePurchaseItemsField } from "../../../store/redux/orders_reducers.js";

import IsLoading from "../../../IsLoading.jsx";
import AlertBar from "../../../AlertBar.jsx";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

import "./orders.css";
import "./purchaseOrders.css";

const newOrderId = () => `PO-${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`}`;

const INITIAL_ORDER = {
  orderId: "",
  orderType: "PURCHASE_ORDERS",

  statusCurrent: "PENDING",
  statusHistoryState_1: "",
  statusHistoryTimestamp_1: "",
  statusHistoryState_2: "",
  statusHistoryTimestamp_2: "",
  statusHistoryApprovedBy_2: "",

  supplierSupplierId: "",
  supplierName: "",
  supplierEmail: "",
  supplierPhone: "",
  supplierAddress: "",

  warehouseWarehouseId: "",
  warehouseName: "",
  warehouseLocation: "",

  itemsProductId_1: "",
  itemsName_1: "",
  itemsQuantity_1: 0,
  itemsUnitPrice_1: 0,
  itemsTotal_1: 0,

  itemsProductId_2: "",
  itemsName_2: "",
  itemsQuantity_2: 0,
  itemsUnitPrice_2: 0,
  itemsTotal_2: 0,

  pricingSubtotal: 0,
  pricingTax: 0,
  pricingDiscount: 0,
  pricingTotalAmount: 0,
  pricingCurrency: "NGN",

  workflowCreatedBy: "",
  workflowApprovedBy: "",
  workflowSentToSupplierAt: "",
  workflowReceivedAt: null,

  deliveryExpectedDeliveryDate: "",
  deliveryActualDeliveryDate: null,
  deliveryDeliveryStatus: "pending",
  deliveryTrackingNumber: "",

  paymentPaymentStatus: "Pending",
  paymentPaymentMethod: "",

  paymentPaidAmount: 0,
  paymentDueAmount: 0,

  approvalRequired: false,
  approvalLevel: "",
  approvalStatus: "",

  notes: "",

  auditTrailAction_1: "",
  auditTrailBy_1: "",
  auditTrailTimestamp_1: "",
  auditTrailAction_2: "",
  auditTrailBy_2: "",
  auditTrailTimestamp_2: "",
  auditTrailAction_3: "",
  auditTrailBy_3: "",
  auditTrailTimestamp_3: "",
};

const INITIAL_ERRORS = {
  statusCurrent: "",
  deliveryExpectedDeliveryDate: "",
  deliveryActualDeliveryDate: "",
  deliveryDeliveryStatus: "",
  paymentPaymentStatus: "",
  paymentPaymentMethod: "",
  cart: "",
};

export default function PurchaseOrders({ initialOrder, duplicate = false, onSaved, onCancel }) {
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [productSearch, setProductSearch] = useState("");
  const [itemsPayloadState, setItemsPayloadState] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMoreActions, setShowMoreActions] = useState(false);
  const [activeSection, setActiveSection] = useState("items");
  const printRef = useRef(null);

  const [inventoriesPayload, setInventoriesPayload] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [selectParty, setSelectParty] = useState("");
  const [savedOrder, setSavedOrder] = useState(duplicate ? null : initialOrder || null);
  const [showPreview, setShowPreview] = useState(false);
  const submittingRef = useRef(false);
  const activeCompanyRef = useRef(null);
  const currentCompanyRef = useRef(null);
  const [selectedInventory, setSelectedInventory] = useState({ inventoryId: initialOrder?.inventoryId || "" });

  const { accessType } = useSelector((state) => state.clientFunction);

  const data = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );

  currentCompanyRef.current = data?.clientId;
  const staffData = useSelector(
    (state) => state.clientFunction?.companiesDB?.staffData,
  );

  const { cart = [] } = useSelector(
    (state) => state.ordersActions?.warehouse || {},
  );

  const [placedOrdersData, setPlacedOrdersData] = useReducer(
    (state, action) => ({
      ...state,
      ...action,
    }),
    { ...INITIAL_ORDER,
      orderId: !duplicate && initialOrder?.orderId ? initialOrder.orderId : newOrderId(),
      statusCurrent: "PENDING",
      supplierSupplierId: initialOrder?.supplier?.supplierId || "",
      supplierName: initialOrder?.supplier?.name || "", supplierEmail: initialOrder?.supplier?.email || "",
      supplierPhone: initialOrder?.supplier?.phone || "", supplierAddress: initialOrder?.supplier?.address || "",
      warehouseWarehouseId: initialOrder?.warehouse?.warehouseId || "", warehouseName: initialOrder?.warehouse?.name || "",
      warehouseLocation: initialOrder?.warehouse?.location || "",
      deliveryExpectedDeliveryDate: initialOrder?.delivery?.expectedDeliveryDate || "",
      deliveryTrackingNumber: initialOrder?.delivery?.trackingNumber || "",
      paymentPaidAmount: duplicate ? 0 : initialOrder?.payment?.paidAmount || 0,
      paymentPaymentMethod: duplicate ? "" : initialOrder?.payment?.paymentMethod || "",
      pricingCurrency: initialOrder?.pricing?.currency || "NGN", notes: initialOrder?.notes || "",
    },
  );

  const [orderValidation, setOrderValidation] = useReducer(
    (state, action) => ({
      ...state,
      ...action,
    }),
    INITIAL_ERRORS,
  );

  const setField = useCallback((field, value) => {
    setPlacedOrdersData({ [field]: value });

    setOrderValidation({
      [field]: "",
    });
  }, []);

  const formatCurrency = useCallback((value) => {
    return Number(value || 0).toLocaleString("en-NG", {
      style: "currency",
      currency: placedOrdersData.pricingCurrency || "NGN",
      minimumFractionDigits: 2,
    });
  }, [placedOrdersData.pricingCurrency]);

  const currencySymbol = { NGN: "₦", USD: "$", EUR: "€", GBP: "£" }[placedOrdersData.pricingCurrency] || placedOrdersData.pricingCurrency;

  const formatDate = useCallback((value) => {
    if (!value) return "—";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return "—";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);

  /*
   * ------------------------------------------------------------
   * LIVE CART CALCULATIONS
   * ------------------------------------------------------------
   */

  const calculatedItems = useMemo(() => {
    return cart?.map((item) => {
      const quantity = Number(item?.orderedQuantity || 0);
      const costPrice = Number(item?.pricing?.costPrice || 0);
      const taxRate = Number(item?.pricing?.taxRate || 0);
      const discount = Math.round((Number(item?.pricing?.discount || 0) + Number.EPSILON) * 100) / 100;

      const round = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
      const subtotal = round(quantity * costPrice);
      const tax = round(subtotal * (taxRate / 100));
      const lineTotal = round(subtotal + tax - round(discount));

      return {
        ...item,
        _quantity: quantity,
        _costPrice: costPrice,
        _taxRate: taxRate,
        _discount: discount,
        _subtotal: subtotal,
        _tax: tax,
        _total: lineTotal,
      };
    });
  }, [cart]);

  const totals = useMemo(() => {
    const subtotal = calculatedItems.reduce(
      (sum, item) => sum + item._subtotal,
      0,
    );

    const tax = calculatedItems.reduce((sum, item) => sum + item._tax, 0);

    const discount = calculatedItems.reduce(
      (sum, item) => sum + item._discount,
      0,
    );

    const total = subtotal + tax - discount;
    const paid = Number(placedOrdersData?.paymentPaidAmount || 0);
    const due = Math.max(total - paid, 0);

    return {
      subtotal: Number(subtotal.toFixed(2)),
      tax: Number(tax.toFixed(2)),
      discount: Number(discount.toFixed(2)),
      total: Number(total.toFixed(2)),
      paid: Number(paid.toFixed(2)),
      due: Number(due.toFixed(2)),
      itemCount: cart?.length,
      quantityCount: calculatedItems.reduce(
        (sum, item) => sum + item._quantity,
        0,
      ),
    };
  }, [calculatedItems, cart?.length, placedOrdersData?.paymentPaidAmount]);

  /*
   * ------------------------------------------------------------
   * PAYLOADS
   * ------------------------------------------------------------
   */
  const itemsOrdered = useMemo(() => {
    return cart?.map((item) => ({
      sku: item?.sku,
      barcode: item?.barcode,
      name: item?.name,
      brand: item?.brand,
      quantity: Number(item?.orderedQuantity || 0),
      taxRate: Number(item?.pricing?.taxRate || 0), discount: Number(item?.pricing?.discount || 0),
      price: Number(item?.pricing?.costPrice || 0),
      expiryDate: item?.expiryDate || null,
      batchNo: item?.batchNo || null,
    }));
  }, [cart]);

  const payload = useMemo(() => {
    return {

      ordersPurchaseRecord: {
        clientId: data?.clientId,
        inventoryId: selectedInventory?.inventoryId || "",
        orderId: placedOrdersData?.orderId,
        orderType: placedOrdersData?.orderType,

        status: {
          current: placedOrdersData?.statusCurrent,
          state: placedOrdersData?.statusHistoryState_2,
          approvedBy: placedOrdersData?.statusHistoryApprovedBy_2,
        },

        supplier: {
          supplierId: placedOrdersData?.supplierSupplierId,
          name: placedOrdersData?.supplierName,
          email: placedOrdersData?.supplierEmail,
          phone: placedOrdersData?.supplierPhone,
          address: placedOrdersData?.supplierAddress,
        },

        warehouse: {
          warehouseId: placedOrdersData?.warehouseWarehouseId,
          name: placedOrdersData?.warehouseName,
          location: placedOrdersData?.warehouseLocation,
        },

        items: itemsOrdered,

        pricing: {
          subtotal: totals.subtotal,
          tax: totals.tax,
          discount: totals.discount,
          totalAmount: totals.total,
          currency: placedOrdersData?.pricingCurrency || "NGN",
        },

        workflow: {
          createdBy: placedOrdersData?.workflowCreatedBy,
          approvedBy: placedOrdersData?.workflowApprovedBy,
          sentToSupplierAt: placedOrdersData?.workflowSentToSupplierAt,
          receivedAt: placedOrdersData?.workflowReceivedAt,
        },

        delivery: {
          expectedDeliveryDate: placedOrdersData?.deliveryExpectedDeliveryDate,
          actualDeliveryDate: placedOrdersData?.deliveryActualDeliveryDate,
          deliveryStatus: placedOrdersData?.deliveryDeliveryStatus,
          trackingNumber: placedOrdersData?.deliveryTrackingNumber,
        },

        payment: {
          paymentStatus: placedOrdersData?.paymentPaymentStatus,
          paymentMethod: placedOrdersData?.paymentPaymentMethod,
          paidAmount: totals.paid,
          dueAmount: totals.due,
        },

        approval: {
          required: placedOrdersData?.approvalRequired,
          level: placedOrdersData?.approvalLevel,
          status: placedOrdersData?.approvalStatus,
        },

        notes: placedOrdersData?.notes,
      },
    };
  }, [selectedInventory?.inventoryId, data?.clientId, placedOrdersData, itemsOrdered, totals]);

  /*
   * ------------------------------------------------------------
   * VALIDATION
   * ------------------------------------------------------------
   */

  const validatePurchaseOrder = (draft = false) => {
    const errors = {};
    if (!draft && !placedOrdersData.supplierSupplierId) errors.supplier = "Select a saved supplier.";
    if ((!draft || cart.length || accessType === "USER_ACCESS") && !selectedInventory.inventoryId) errors.inventory = "Select a receiving inventory.";
    if (!draft && !placedOrdersData.deliveryExpectedDeliveryDate) errors.deliveryExpectedDeliveryDate = "Expected delivery date is required.";
    if (!draft && !cart.length) errors.cart = "Add at least one item.";
    if (calculatedItems.some((item) => !Number.isFinite(item._quantity) || item._quantity <= 0 || !Number.isFinite(item._costPrice) || item._costPrice < 0 || item._taxRate < 0 || item._taxRate > 100 || item._discount < 0 || item._total < 0)) errors.cart = "Review quantities, unit costs, tax and discounts.";
    if (!Number.isFinite(totals.paid) || totals.paid < 0 || totals.paid > totals.total) errors.paymentPaymentStatus = "Paid amount must be between zero and the total.";
    if (totals.paid > 0 && !placedOrdersData.paymentPaymentMethod) errors.paymentPaymentMethod = "Select the recorded payment method.";
    setOrderValidation({ ...INITIAL_ERRORS, ...errors });
    if (Object.keys(errors).length) { setAlert({ message: Object.values(errors).join(" "), type: "error" }); return false; }
    return true;
  };

  const openProductSearch = useCallback(() => {
    setProductSearch("");
    setShowProductSearch(true);
  }, []);

  //   /////////////////////////////////////////////////////////////////////////
  //   // REDUX FUCNTIONS
  //   /////////////////////////////////////////////////////////////////////////

  const addToCart = useCallback(
    (product) => {
      // Check if item already exists in cart
      const existingItem = cart.find(
        (cartItem) => cartItem.sku === product.sku,
      );

      if (existingItem) {
        // If exists, update quantity
        enqueueSnackbar(`Item already in cart`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        // dispatch(Action.addtoCart(updatedItem));
      } else {
        // If not exists, add new item

        const inventory = product.inventories?.find((entry) => entry.inventoryId === selectedInventory.inventoryId);
        if (!inventory) { setAlert({ message: "Select an inventory containing this item.", type: "error" }); return; }
        const intoCart = {
          sku: product.sku, name: product.name, brand: product.brand, orderedQuantity: 1,
          unit: product.units?.baseUnit || "", barcode: product.barcode || "",
          pricing: { costPrice: product.pricing?.costPrice || 0, taxRate: product.pricing?.taxRate || 0, discount: 0 },
          inventory: { inventoryId: inventory.inventoryId, quantity: inventory.stock?.quantity },
          batchNo: "", expiryDate: "", attribute: product.productType,
        };
        dispatch(Action.addtoCart({ intoCart, recieptNo: placedOrdersData.orderId }));
        setShowProductSearch(false);
      }
    },
    [cart, dispatch, enqueueSnackbar, selectedInventory.inventoryId, placedOrdersData.orderId],
  );
  /*
   * ------------------------------------------------------------
   * API
   * ------------------------------------------------------------
   */

  const apiPostOrders = async (action = "PLACE_ORDER") => {
    if (typeof action !== "string") action = "PLACE_ORDER";
    if (submittingRef.current || !data?.clientId || !validatePurchaseOrder(action === "SAVE_DRAFT")) return;
    if (savedOrder && savedOrder.status?.current !== "DRAFT") {
      setAlert({ message: "This order is already placed. Use Duplicate Order for a new purchase.", type: "info" }); return;
    }
    submittingRef.current = true;
    setLoading(true);
    try {
      const emitUniCloud = action === "PLACE_ORDER" && accessType === "CLIENT_ACCESS" && data?.uniCloud?.isUniCloudDeviceActivated === true;
      const response = await axios.post(`${serverHost}/client/${encodeURIComponent(data.clientId)}/purchases/post_order?emitUniCloud=${emitUniCloud}`,
        { payload: { ...payload, action, expectedRevision: savedOrder?.revision || 0 } });
      if (response.data.status !== 200 || !response.data.info?.orderId) throw new Error(response.data.message || "Unable to save this order.");
      if (currentCompanyRef.current !== data.clientId) return;
      setSavedOrder(response.data.info);
      setAlert({ message: response.data.message, type: "added" });
      if (onSaved) onSaved(response.data.info);
      else setShowPreview(true);
    } catch (error) {
      if (currentCompanyRef.current !== data.clientId) return;
      setAlert({ message: error.response?.data?.message || error.message || "Purchase could not be confirmed. Retry the same order ID.", type: "error" });
    } finally { submittingRef.current = false; if (currentCompanyRef.current === data.clientId) setLoading(false); }
  };

  const duplicateOrder = () => {
    setSavedOrder(null);
    setPlacedOrdersData({ orderId: newOrderId(), statusCurrent: "PENDING", paymentPaidAmount: 0, paymentPaymentMethod: "" });
    setShowMoreActions(false);
  };

  const cancelOrder = async () => {
    if (!savedOrder) { dispatch(Action.clearCartAction()); if (onCancel) onCancel(); else navigate("/advance-companies-management-system/company-account"); return; }
    if (submittingRef.current) return;
    submittingRef.current = true; setLoading(true);
    try {
      const response = await axios.post(`${serverHost}/client/${encodeURIComponent(data.clientId)}/purchases/post_order`,
        { payload: { action: "CANCEL_ORDER", orderId: savedOrder.orderId, expectedRevision: savedOrder.revision } });
      if (response.data.status !== 200) throw new Error(response.data.message);
      if (currentCompanyRef.current !== data.clientId) return;
      setSavedOrder(response.data.info); setAlert({ message: response.data.message, type: "added" });
      if (onSaved) onSaved(response.data.info);
    } catch (error) { if (currentCompanyRef.current === data.clientId) setAlert({ message: error.response?.data?.message || error.message, type: "error" }); }
    finally { submittingRef.current = false; if (currentCompanyRef.current === data.clientId) setLoading(false); }
  };

  const chooseInventory = (inventory) => {
    setSelectedInventory(inventory);
    setPlacedOrdersData({ warehouseWarehouseId: inventory.warehouseId || "", warehouseName: inventory.name || inventory.inventoryName || inventory.inventoryId,
      warehouseLocation: typeof inventory.address === "string" ? inventory.address : [inventory.address?.street, inventory.address?.city, inventory.address?.state].filter(Boolean).join(", ") });
    setSelectParty("");
  };

  const chooseSupplier = (supplier) => {
    setPlacedOrdersData({ supplierSupplierId: supplier.business?.supplierId || supplier.contactId || supplier._id,
      supplierName: supplier.profile?.fullName || supplier.contact?.company?.name || "",
      supplierEmail: supplier.contact?.email?.primary || "", supplierPhone: supplier.contact?.phone?.primary || "",
      supplierAddress: [supplier.contact?.address?.street, supplier.contact?.address?.city, supplier.contact?.address?.state].filter(Boolean).join(", ") });
    setSelectParty("");
  };

  useEffect(() => {
    if (!data?.clientId) return;
    const controller = new AbortController();
    setItemsPayloadState([]); setInventoriesPayload([]); setSuppliers([]);
    if (activeCompanyRef.current && activeCompanyRef.current !== data.clientId) {
      setPlacedOrdersData({ ...INITIAL_ORDER, orderId: newOrderId() }); setSelectedInventory({}); setSavedOrder(null); setShowPreview(false); setSelectParty("");
    }
    const restore = !initialOrder?.clientId || initialOrder.clientId === data.clientId ? initialOrder : null;
    activeCompanyRef.current = data.clientId;
    dispatch(Action.attandOnhold({ buyings: (restore?.items || []).map((line) => ({
      sku: line.sku || line.productId, name: line.name, brand: line.brand, orderedQuantity: line.quantity,
      pricing: { costPrice: line.price ?? line.unitPrice, taxRate: line.taxRate || 0, discount: line.discount || 0 },
      inventory: { inventoryId: restore.inventoryId }, batchNo: line.batchNo || "", expiryDate: line.expiryDate || "",
    })) }));
    const load = async () => {
      setLoading(true);
      const requests = [
        ["items", `${serverHost}/ordersPlacing/client/${encodeURIComponent(data.clientId)}/get-items`, "itemsResults", setItemsPayloadState],
        ["inventories", `${serverHost}/conditionalInventoryFetch/get-inventories/${encodeURIComponent(data.clientId)}`, "inventoriesData", setInventoriesPayload],
        ["suppliers", `${serverHost}/client/${encodeURIComponent(data.clientId)}/contacts/fetch_contact`, "nContact", setSuppliers],
      ];
      const results = await Promise.allSettled(requests.map(async ([label, url, field, setter]) => {
        const response = await axios.get(url, { signal: controller.signal });
        if (![200, 201].includes(response.data.status)) throw new Error(response.data.message || `Unable to load ${label}.`);
        const records = response.data[field] || response.data.contactsData || [];
        if (!controller.signal.aborted) setter(label === "suppliers" ? records.filter((entry) => String(entry.profile?.type).toLowerCase().includes("supplier")) : records);
      }));
      if (!controller.signal.aborted) { const failure = results.find((entry) => entry.status === "rejected"); if (failure) setAlert({ message: failure.reason.response?.data?.message || failure.reason.message, type: "error" }); setLoading(false); }
    };
    load();
    return () => controller.abort();
  }, [data?.clientId, dispatch, initialOrder]);

  const availableItems = itemsPayloadState.filter((item) => item.inventories?.some((inventory) => inventory.inventoryId === selectedInventory.inventoryId));

  /*
   * ------------------------------------------------------------
   * WORKFLOW
   * ------------------------------------------------------------
   */

  const workflowSteps = [
    {
      key: "PENDING",
      label: "Draft",
      description: "Order is being prepared",
    },
    {
      key: "APPROVED",
      label: "Approved",
      description: "Awaiting supplier processing",
    },
    {
      key: "PROCESSING",
      label: "Ordered",
      description: "Supplier is processing order",
    },
    {
      key: "PARTIALLY_RECEIVED",
      label: "Partially Received",
      description: "Some items received",
    },
    {
      key: "RECEIVED",
      label: "Received",
      description: "All items received",
    },
    {
      key: "COMPLETED",
      label: "Completed",
      description: "Purchase order completed",
    },
  ];

  const currentWorkflowIndex = Math.max(
    workflowSteps.findIndex(
      (step) => step.key === placedOrdersData?.statusCurrent,
    ),
    0,
  );

  const orderNumber = placedOrdersData.orderId;

  const supplierName = placedOrdersData?.supplierName || "No supplier selected";

  const warehouseName =
    placedOrdersData?.warehouseName || "No warehouse selected";

  const printOrder = useReactToPrint({
    contentRef: printRef,
  });

  return (
    <>
      {alert && <AlertBar alert={alert} setAlert={setAlert} />}

      {loading && <IsLoading />}
      {showProductSearch && (
        <ProductSearchModal
          products={availableItems}
          searchValue={productSearch}
          setSearchValue={setProductSearch}
          cart={cart}
          formatCurrency={formatCurrency}
          onClose={() => setShowProductSearch(false)}
          onAddProduct={addToCart}
        />
      )}
      {showPreview && savedOrder && <div className="client_modal_overlay fx-jc fx-ac" onClick={() => setShowPreview(false)}><div className="client_modal" onClick={(event) => event.stopPropagation()}><PurchaseOrdersPreview purchaseOrderItem={savedOrder} onClose={() => setShowPreview(false)} /></div></div>}
      {selectParty && <div className="client_modal_overlay fx-jc fx-ac" onClick={() => setSelectParty("")}><div className="client_modal" onClick={(event) => event.stopPropagation()}>
        <div id="createCont" className="fx-cl space2"><h3>Select {selectParty === "supplier" ? "Supplier" : "Receiving Inventory"}</h3>
          {(selectParty === "supplier" ? suppliers : inventoriesPayload).map((entry) => <button key={entry._id || entry.inventoryId} className="apoPartyCard" onClick={() => selectParty === "supplier" ? chooseSupplier(entry) : chooseInventory(entry)}>{selectParty === "supplier" ? entry.profile?.fullName || entry.contact?.company?.name : entry.name || entry.inventoryName || entry.inventoryId}</button>)}
          {!(selectParty === "supplier" ? suppliers : inventoriesPayload).length && <p>No saved {selectParty === "supplier" ? "suppliers" : "inventories"} are available.</p>}
          <button className="apoSecondaryButton" onClick={() => setSelectParty("")}>Close</button>
        </div>
      </div></div>}
      <div className="advancedPurchaseOrderPage">
        {/* ======================================================
            HEADER
        ====================================================== */}

        <header className="apoHeader">
          <div className="apoHeaderLeft">
            <div className="apoBreadcrumb">
              <span>Procurement</span>
              <span>/</span>
              <strong>Purchase Orders</strong>
            </div>

            <div className="apoTitleRow">
              <div>
                <div className="apoTitleLine">
                  <h1>Purchase Order</h1>

                  <span
                    className={`apoStatus apoStatus--${String(
                      placedOrdersData?.statusCurrent || "pending",
                    ).toLowerCase()}`}
                  >
                    <span />
                    {String(
                      placedOrdersData?.statusCurrent || "Draft",
                    ).replaceAll("_", " ")}
                  </span>
                </div>

                <div className="apoOrderMeta">
                  <span>{orderNumber}</span>
                  <i />
                  <span>Created {formatDate(!duplicate && initialOrder?.createdAt ? initialOrder.createdAt : savedOrder?.createdAt || new Date())}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="apoHeaderActions">
            <button
              type="button"
              className="apoSecondaryButton"
              onClick={() => savedOrder ? setShowPreview(true) : printOrder()}
            >
              <LocalPrintshopIcon />
              Print
            </button>

            <button
              type="button"
              className="apoSecondaryButton"
              disabled={loading || (savedOrder && savedOrder.status?.current !== "DRAFT")}
              onClick={() => apiPostOrders("SAVE_DRAFT")}
            >
              <SaveOutlinedIcon />
              Save Draft
            </button>

            <button
              type="button"
              className="apoPrimaryButton"
              disabled={loading || (savedOrder && savedOrder.status?.current !== "DRAFT")}
              onClick={() => apiPostOrders("PLACE_ORDER")}
            >
              <SendOutlinedIcon />
              Complete Order
            </button>

            <div className="apoMoreWrapper">
              <button
                type="button"
                className="apoIconButton"
                onClick={() => setShowMoreActions((value) => !value)}
              >
                <MoreVertIcon />
              </button>

              {showMoreActions && (
                <div className="apoMoreMenu">
                  <button type="button" onClick={duplicateOrder}>Duplicate order</button>

                  <ExportPDFButton currentRows={[savedOrder || payload.ordersPurchaseRecord]} label="Export PDF" />

                  <button type="button" disabled={!placedOrdersData.supplierEmail} onClick={() => {
                    window.location.href = `mailto:${encodeURIComponent(placedOrdersData.supplierEmail)}?subject=${encodeURIComponent(`Purchase order ${orderNumber}`)}&body=${encodeURIComponent(`Purchase order ${orderNumber}\nItems: ${totals.itemCount}\nTotal: ${formatCurrency(totals.total)}\nPlease find the exported purchase order attached.`)}`;
                  }}>Email supplier</button>

                  <button type="button" className="apoDangerAction" disabled={loading} onClick={cancelOrder}>
                    Cancel order
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* ======================================================
            WORKFLOW
        ====================================================== */}

        <section className="apoWorkflowCard">
          <div className="apoWorkflowTop">
            <div>
              <span className="apoEyebrow">ORDER WORKFLOW</span>

              <h2>Purchase progress</h2>
            </div>

            <span className="apoWorkflowProgress">
              Step {currentWorkflowIndex + 1} of {workflowSteps.length}
            </span>
          </div>

          <div className="apoWorkflow">
            {workflowSteps.map((step, index) => {
              const complete = index < currentWorkflowIndex;

              const active = index === currentWorkflowIndex;

              return (
                <React.Fragment key={step.key}>
                  <div
                    className={`apoWorkflowStep ${
                      complete ? "isComplete" : ""
                    } ${active ? "isActive" : ""}`}
                  >
                    <div className="apoWorkflowCircle">
                      {complete ? (
                        <CheckCircleIcon />
                      ) : active ? (
                        <span>{index + 1}</span>
                      ) : (
                        <RadioButtonUncheckedIcon />
                      )}
                    </div>

                    <div>
                      <strong>{step.label}</strong>
                      <small>
                        {active ? "Current stage" : step.description}
                      </small>
                    </div>
                  </div>

                  {index < workflowSteps.length - 1 && (
                    <div
                      className={`apoWorkflowLine ${
                        index < currentWorkflowIndex ? "isComplete" : ""
                      }`}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </section>

        {/* ======================================================
            BODY
        ====================================================== */}

        <div className="apoWorkspace">
          <main className="apoMain">
            {/* ORDER DETAILS */}

            <section className="apoCard" id="order-details">
              <CardHeader
                icon={<ReceiptLongOutlinedIcon />}
                eyebrow="ORDER CONFIGURATION"
                title="Order details"
                description="Define the purchase order status, delivery schedule and payment terms."
              />

              <div className="apoFormGrid apoFormGrid--4">
                <Field
                  label="Order type"
                  value={placedOrdersData?.orderType || "PURCHASE_ORDERS"}
                  onChange={(e) => setField("orderType", e.target.value)}
                >
                  <select>
                    <option value="PURCHASE_ORDERS">Purchase Order</option>
                    
                  </select>
                </Field>

                <Field
                  label="Current status"
                  error={orderValidation?.statusCurrent}
                  value={placedOrdersData?.statusCurrent || ""}
                  onChange={(e) => setField("statusCurrent", e.target.value)}
                >
                  <select>
                    <option value="">Select status</option>
                    <option value="PENDING">Pending</option>
                    <option value="APPROVED">Approved</option>
                    <option value="PROCESSING">Processing</option>



                  </select>
                </Field>

                <Field
                  label="Expected delivery"
                  error={orderValidation?.deliveryExpectedDeliveryDate}
                >
                  <div className="apoInputIcon">
                    <CalendarTodayOutlinedIcon />

                    <input
                      type="date"
                      value={
                        placedOrdersData?.deliveryExpectedDeliveryDate
                          ? new Date(
                              placedOrdersData.deliveryExpectedDeliveryDate,
                            )
                              .toISOString()
                              .split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        setField("deliveryExpectedDeliveryDate", e.target.value)
                      }
                    />
                  </div>
                </Field>

                <Field label="Currency">
                  <div className="apoReadOnlyField">
                    <strong>{currencySymbol}</strong>
                    <span>{placedOrdersData?.pricingCurrency || "NGN"}</span>
                  </div>
                </Field>
              </div>
            </section>

            {/* SUPPLIER / WAREHOUSE */}

            <section className="apoCard">
              <CardHeader
                icon={<PersonOutlineIcon />}
                eyebrow="PARTIES"
                title="Supplier & destination"
                description="Identify the supplier and warehouse receiving this purchase."
              />

              <div className="apoPartyGrid">
                <PartyCard
                  icon={<PersonOutlineIcon />}
                  label="SUPPLIER"
                  title={
                    placedOrdersData?.supplierName || "Supplier not selected"
                  }
                  secondary={
                    placedOrdersData?.supplierEmail || "Email not recorded"
                  }
                  tertiary={
                    placedOrdersData?.supplierPhone || "Add supplier phone"
                  }
                  onClick={() => setSelectParty("supplier")}
                />

                <PartyCard
                  icon={<WarehouseOutlinedIcon />}
                  label="DESTINATION"
                  title={
                    placedOrdersData?.warehouseName || "Warehouse not selected"
                  }
                  secondary={
                    placedOrdersData?.warehouseLocation ||
                    "Select receiving warehouse"
                  }
                  tertiary={
                    placedOrdersData?.warehouseWarehouseId || "No warehouse ID"
                  }
                  onClick={() => setSelectParty("inventory")}
                />
              </div>

              <div className="apoInlineFormGrid">
                <Field label="Supplier name" error={orderValidation.supplier}>
                  <input
                    value={placedOrdersData?.supplierName || ""}
                    placeholder="Enter supplier name"
                    onChange={(e) => setField("supplierName", e.target.value)}
                  />
                </Field>

                <Field label="Supplier email">
                  <input
                    type="email"
                    value={placedOrdersData?.supplierEmail || ""}
                    placeholder="supplier@example.com"
                    onChange={(e) => setField("supplierEmail", e.target.value)}
                  />
                </Field>

                <Field label="Supplier phone">
                  <input
                    value={placedOrdersData?.supplierPhone || ""}
                    placeholder="+234..."
                    onChange={(e) => setField("supplierPhone", e.target.value)}
                  />
                </Field>

                <Field label="Supplier address">
                  <input
                    value={placedOrdersData?.supplierAddress || ""}
                    placeholder="Supplier address"
                    onChange={(e) =>
                      setField("supplierAddress", e.target.value)
                    }
                  />
                </Field>
              </div>
            </section>

            {/* ITEMS */}

            <section className="apoCard apoItemsCard" id="items">
              <CardHeader
                icon={<Inventory2OutlinedIcon />}
                eyebrow="PURCHASE ITEMS"
                title="Line items"
                description={`${totals.itemCount} items · ${totals.quantityCount} total units`}
                action={
                  <button
                    type="button"
                    className="apoAddProductButton"
                    onClick={() => openProductSearch()}
                  >
                    <AddIcon />
                    Add item
                  </button>
                }
              />

              {orderValidation?.cart && (
                <div className="apoValidationBanner">
                  <WarningAmberOutlinedIcon />
                  {orderValidation.cart}
                </div>
              )}

              <ItemsList supplierName={placedOrdersData.supplierName} formatCurrency={formatCurrency} currencySymbol={currencySymbol} />

              {!cart?.length && (
                <EmptyItemsState onAddProduct={openProductSearch} />
              )}
            </section>

            {/* DELIVERY */}

            <section className="apoCard" id="delivery">
              <CardHeader
                icon={<LocalShippingOutlinedIcon />}
                eyebrow="FULFILLMENT"
                title="Delivery & receiving"
                description="Track how and when this purchase is expected to arrive."
              />

              <div className="apoFormGrid apoFormGrid--3">
                <Field
                  label="Delivery status"
                  error={orderValidation?.deliveryDeliveryStatus}
                >
                  <select
                    disabled
                    value="pending"
                    onChange={(e) => {
                      const value = e.target.value;

                      setPlacedOrdersData({
                        deliveryDeliveryStatus: value,
                        deliveryActualDeliveryDate:
                          value === "delivered"
                            ? placedOrdersData?.deliveryActualDeliveryDate
                            : null,
                      });

                      setOrderValidation({
                        deliveryDeliveryStatus: "",
                        deliveryActualDeliveryDate: "",
                      });
                    }}
                  >
                    <option value="">Select status</option>
                    <option value="pending">Pending</option>
                    <option value="processing">Processing</option>
                    <option value="shipped">Shipped</option>
                    <option value="out_for_delivery">Out for delivery</option>
                    <option value="delivered">Delivered (updated by receiving)</option>
                  </select>
                </Field>

                <Field
                  label="Actual delivery (recorded by receiving)"
                  error={orderValidation?.deliveryActualDeliveryDate}
                >
                  <input
                    type="date"
                    value={
                      placedOrdersData?.deliveryActualDeliveryDate
                        ? new Date(placedOrdersData.deliveryActualDeliveryDate)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    onChange={(e) =>
                      setField("deliveryActualDeliveryDate", e.target.value)
                    }
                  />
                </Field>

                <Field label="Tracking number">
                  <input
                    value={placedOrdersData?.deliveryTrackingNumber || ""}
                    placeholder="e.g. DHL-4928301"
                    onChange={(e) =>
                      setField("deliveryTrackingNumber", e.target.value)
                    }
                  />
                </Field>
              </div>
            </section>

            {/* PAYMENT */}

            <section className="apoCard" id="payment">
              <CardHeader
                icon={<PaymentsOutlinedIcon />}
                eyebrow="FINANCIALS"
                title="Payment"
                description="Configure payment status, method and settlement."
              />

              <div className="apoFormGrid apoFormGrid--4">
                <Field
                  label="Payment status"
                  error={orderValidation?.paymentPaymentStatus}
                >
                  <select
                    disabled
                    value={totals.paid >= totals.total && totals.total > 0 ? "Paid" : totals.paid > 0 ? "Partially Paid" : "Pending"}
                    onChange={(e) =>
                      setField("paymentPaymentStatus", e.target.value)
                    }
                  >
                    <option value="">Select payment status</option>
                    <option value="Pending">Pending</option>
                    <option value="Paid">Paid</option>
                    <option value="Partially Paid">Partially Paid</option>
                    <option value="Failed">Failed</option>
                  </select>
                </Field>

                <Field
                  label="Payment method"
                  error={orderValidation?.paymentPaymentMethod}
                >
                  <select
                    value={placedOrdersData?.paymentPaymentMethod || ""}
                    onChange={(e) =>
                      setField("paymentPaymentMethod", e.target.value)
                    }
                  >
                    <option value="">Select method</option>
                    <option value="Cash">Cash</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Credit Card">Credit Card</option>
                    <option value="Debit Card">Debit Card</option>
                    <option value="Mobile Money">Mobile Money</option>
                    <option value="POS">POS</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Online Payment">Online Payment</option>
                    <option value="Wallet">Wallet</option>
                  </select>
                </Field>

                <Field label="Amount paid">
                  <input
                    type="number"
                    min="0"
                    value={placedOrdersData?.paymentPaidAmount ?? 0}
                    onChange={(e) =>
                      setField("paymentPaidAmount", Number(e.target.value || 0))
                    }
                    onWheel={(e) => e.preventDefault()}
                  />
                </Field>

                <Field label="Amount due">
                  <div className="apoReadOnlyField">
                    <span>{formatCurrency(totals.due)}</span>
                  </div>
                </Field>
              </div>
            </section>

            {/* NOTES */}

            <section className="apoCard" id="notes">
              <CardHeader
                icon={<NotesOutlinedIcon />}
                eyebrow="INSTRUCTIONS"
                title="Notes & instructions"
                description="Add internal notes or instructions for the supplier and receiving team."
              />

              <ReactQuill
                className="apoRichEditor"
                theme="snow"
                value={placedOrdersData?.notes || ""}
                onChange={(notes) => setPlacedOrdersData({ notes })}
                placeholder="Add purchase order notes, delivery instructions, special handling requirements..."
              />
            </section>

            {/* FOOTER ACTION */}

            <section className="apoFinalAction">
              <div>
                <span className="apoFinalIcon">
                  <CheckCircleIcon />
                </span>

                <div>
                  <h3>Ready to complete this order?</h3>
                  <p>
                    Review the supplier, items, pricing and delivery information
                    before submitting.
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="apoPrimaryButton apoPrimaryButton--large"
                disabled={loading || (savedOrder && savedOrder.status?.current !== "DRAFT")}
              onClick={() => apiPostOrders("PLACE_ORDER")}
              >
                <SendOutlinedIcon />
                Complete Purchase Order
              </button>
            </section>
          </main>

          {/* ====================================================
              STICKY SUMMARY
          ==================================================== */}

          <aside className="apoSidebar">
            <div className="apoSummaryCard">
              <div className="apoSummaryHeader">
                <div>
                  <span className="apoEyebrow">ORDER SUMMARY</span>
                  <h2>{orderNumber}</h2>
                </div>

                <span className="apoSummaryStatus">{savedOrder?.status?.current || "Unsaved"}</span>
              </div>

              <div className="apoSummaryParties">
                <SummaryParty
                  icon={<PersonOutlineIcon />}
                  label="SUPPLIER"
                  value={supplierName}
                />

                <SummaryParty
                  icon={<WarehouseOutlinedIcon />}
                  label="DELIVER TO"
                  value={warehouseName}
                />

                <SummaryParty
                  icon={<CalendarTodayOutlinedIcon />}
                  label="EXPECTED"
                  value={formatDate(
                    placedOrdersData?.deliveryExpectedDeliveryDate,
                  )}
                />
              </div>

              <div className="apoSummaryDivider" />

              <div className="apoFinancialRows">
                <SummaryRow
                  label={`Subtotal (${totals.itemCount} items)`}
                  value={formatCurrency(totals.subtotal)}
                />

                <SummaryRow label="Tax" value={formatCurrency(totals.tax)} />

                <SummaryRow
                  label="Discount"
                  value={`-${formatCurrency(totals.discount)}`}
                  negative
                />
              </div>

              <div className="apoTotalBox">
                <div>
                  <span>Order total</span>
                  <small>Including applicable tax</small>
                </div>

                <strong>{formatCurrency(totals.total)}</strong>
              </div>

              <div className="apoPaymentSummary">
                <SummaryRow label="Paid" value={formatCurrency(totals.paid)} />

                <SummaryRow
                  label="Outstanding"
                  value={formatCurrency(totals.due)}
                  emphasis
                />
              </div>

              <button
                type="button"
                className="apoSidebarSubmit"
                disabled={loading || (savedOrder && savedOrder.status?.current !== "DRAFT")}
              onClick={() => apiPostOrders("PLACE_ORDER")}
              >
                <SendOutlinedIcon />
                Complete purchase
              </button>

              <div className="apoSecureNote">
                <CheckCircleIcon />
                Your purchase data will be securely recorded.
              </div>
            </div>

            {/* QUICK NAVIGATION */}

            <div className="apoQuickNav">
              <span className="apoEyebrow">QUICK NAVIGATION</span>

              {[
                ["order-details", "Order details"],
                ["items", "Line items"],
                ["delivery", "Delivery"],
                ["payment", "Payment"],
                ["notes", "Notes"],
              ].map(([target, label]) => (
                <button
                  type="button"
                  key={target}
                  className={activeSection === target ? "isActive" : ""}
                  onClick={() => {
                    setActiveSection(target);

                    document.getElementById(target)?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  <span>{label}</span>
                  <span>›</span>
                </button>
              ))}
            </div>
          </aside>
        </div>

        {/* PRINT AREA */}

        <div ref={printRef} className="apoPrintArea">
          <h1>Purchase Order</h1>
          <h2>{orderNumber}</h2>

          <p>Supplier: {supplierName}</p>

          <p>Warehouse: {warehouseName}</p>

          <hr />

          {calculatedItems.map((item, index) => (
            <div key={item?.sku || index}>
              {item?.name} — {item?._quantity} ×{" "}
              {formatCurrency(item?._costPrice)} ={" "}
              {formatCurrency(item?._total)}
            </div>
          ))}

          <hr />

          <strong>Total: {formatCurrency(totals.total)}</strong>
        </div>
      </div>
    </>
  );
}

/* ================================================================
   ITEMS LIST
================================================================ */

function ItemsList({ supplierName, formatCurrency, currencySymbol }) {
  const dispatch = useDispatch();

  const cart = useSelector(
    (state) => state.ordersActions?.warehouse?.cart || [],
  );

  const [expandedItem, setExpandedItem] = useState(null);

  const updatePurchaseItemsField = (index, field, value) => {
    dispatch(
      onchangePurchaseItemsField({
        index,
        field,
        value,
      }),
    );
  };

  const updateQuantity = (index, quantity) => {
    const safeQuantity = Math.max(1, Number(quantity || 1));

    updatePurchaseItemsField(index, "orderedQuantity", safeQuantity);
  };

  const removeItem = (index) => {
    dispatch(Action.removeFromCart(index));
  };

  if (!cart?.length) return null;

  return (
    <div className="apoItemsTable">
      <div className="apoItemsTableHeader">
        <span>ITEM</span>
        <span>SUPPLIER</span>
        <span>QUANTITY</span>
        <span>UNIT COST</span>
        <span>TAX</span>
        <span>LINE TOTAL</span>
        <span />
      </div>

      {cart?.map((item, index) => {
        const quantity = Number(item?.orderedQuantity || 0);

        const cost = Number(item?.pricing?.costPrice || 0);

        const taxRate = Number(item?.pricing?.taxRate || 0);

        const discount = Math.round((Number(item?.pricing?.discount || 0) + Number.EPSILON) * 100) / 100;

        const subtotal = Math.round((quantity * cost + Number.EPSILON) * 100) / 100;
        const tax = Math.round((subtotal * taxRate / 100 + Number.EPSILON) * 100) / 100;
        const total = Math.round((subtotal + tax - discount + Number.EPSILON) * 100) / 100;

        const expanded = expandedItem === index;

        return (
          <div
            className={`apoItemRow ${expanded ? "isExpanded" : ""}`}
            key={item?.sku || index}
          >
            <div className="apoItemMain">
              <div className="apoProductAvatar">
                {item?.image ? (
                  <img src={item.image} alt={item?.name || "Product"} />
                ) : (
                  <ShoppingCartIcon />
                )}
              </div>

              <div className="apoProductDetails">
                <strong>{item?.name || "Unnamed product"}</strong>

                <div>
                  <span>SKU: {item?.sku || "N/A"}</span>

                  {item?.barcode && (
                    <>
                      <i />
                      <span>{item.barcode}</span>
                    </>
                  )}
                </div>

                <small>{item?.brand || "Unbranded product"}</small>
              </div>
            </div>

            <div className="apoSupplierCell">
              <input
                value={supplierName || ""}
                placeholder="Supplier"
                readOnly
              />
            </div>

            <div className="apoQuantityCell">
              <button
                type="button"
                onClick={() => updateQuantity(index, quantity - 1)}
              >
                <RemoveIcon />
              </button>

              <input
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => updateQuantity(index, e.target.value)}
                onWheel={(e) => e.preventDefault()}
              />

              <button
                type="button"
                onClick={() => updateQuantity(index, quantity + 1)}
              >
                <AddIcon />
              </button>
            </div>

            <div className="apoMoneyInput">
              <span>{currencySymbol}</span>

              <input
                type="number"
                min="0"
                value={cost}
                onChange={(e) =>
                  updatePurchaseItemsField(
                    index,
                    "costPrice",
                    Number(e.target.value || 0),
                  )
                }
                onWheel={(e) => e.preventDefault()}
              />
            </div>

            <div className="apoTaxInput">
              <input
                type="number"
                min="0"
                max="100"
                value={taxRate}
                onChange={(e) =>
                  updatePurchaseItemsField(
                    index,
                    "taxRate",
                    Number(e.target.value || 0),
                  )
                }
                onWheel={(e) => e.preventDefault()}
              />

              <span>%</span>
            </div>

            <div className="apoLineTotal">
              <strong>
                {formatCurrency(total)}
              </strong>

              <small>
                {quantity} × {formatCurrency(cost)}
              </small>
            </div>

            <div className="apoItemActions">
              <button
                type="button"
                className={expanded ? "isActive" : ""}
                onClick={() => setExpandedItem(expanded ? null : index)}
              >
                <ExpandMoreIcon />
              </button>

              <button
                type="button"
                className="apoDeleteButton"
                onClick={() => removeItem(index)}
              >
                <DeleteOutlineIcon />
              </button>
            </div>

            {expanded && (
              <div className="apoExpandedDetails">
                <div>
                  <label>Batch / Lot number</label>

                  <input
                    value={item?.batchNo || ""}
                    placeholder="Batch number"
                    onChange={(e) =>
                      updatePurchaseItemsField(index, "batchNo", e.target.value)
                    }
                  />
                </div>

                <div>
                  <label>Discount</label>

                  <input
                    type="number"
                    min="0"
                    value={discount}
                    onChange={(e) =>
                      updatePurchaseItemsField(
                        index,
                        "discount",
                        Number(e.target.value || 0),
                      )
                    }
                    onWheel={(e) => e.preventDefault()}
                  />
                </div>

                <div>
                  <label>Unit of measure</label>

                  <input
                    value={item?.unit || ""}
                    placeholder="e.g. Carton"
                    readOnly
                  />
                </div>

                <div>
                  <label>Available stock</label>

                  <div className="apoStockValue">
                    {item?.inventory?.quantity ?? item?.quantity ?? "Not recorded"}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

/* ================================================================
   COMPONENTS
================================================================ */

function CardHeader({ icon, eyebrow, title, description, action }) {
  return (
    <div className="apoCardHeader">
      <div className="apoCardHeaderIcon">{icon}</div>

      <div className="apoCardHeaderContent">
        <span className="apoEyebrow">{eyebrow}</span>

        <h2>{title}</h2>

        {description && <p>{description}</p>}
      </div>

      {action && <div className="apoCardHeaderAction">{action}</div>}
    </div>
  );
}

function Field({ label, children, error }) {
  return (
    <div className={`apoField ${error ? "hasError" : ""}`}>
      <label>{label}</label>

      {children}

      {error && <small className="apoFieldError">{error}</small>}
    </div>
  );
}

function PartyCard({ icon, label, title, secondary, tertiary, onClick }) {
  return (
    <button type="button" className="apoPartyCard" onClick={onClick}>
      <div className="apoPartyIcon">{icon}</div>

      <div className="apoPartyContent">
        <span>{label}</span>
        <strong>{title}</strong>
        <small>{secondary}</small>
        <small>{tertiary}</small>
      </div>

      <span className="apoPartyArrow">→</span>
    </button>
  );
}

function SummaryParty({ icon, label, value }) {
  return (
    <div className="apoSummaryParty">
      <div>{icon}</div>

      <section>
        <span>{label}</span>
        <strong>{value}</strong>
      </section>
    </div>
  );
}

function SummaryRow({ label, value, negative, emphasis }) {
  return (
    <div className={`apoSummaryRow ${emphasis ? "isEmphasis" : ""}`}>
      <span>{label}</span>

      <strong className={negative ? "apoNegative" : ""}>{value}</strong>
    </div>
  );
}

function EmptyItemsState({ onAddProduct }) {
  return (
    <div className="apoEmptyItems">
      <div className="apoEmptyIcon">
        <Inventory2OutlinedIcon />
      </div>

      <h3>No items added yet</h3>

      <p>
        Search your inventory and add items to start building this purchase
        order.
      </p>

      <button type="button" onClick={onAddProduct}>
        <AddIcon />
        Add your first item
      </button>
    </div>
  );
}

function ProductSearchModal({
  products = [],
  searchValue,
  setSearchValue,
  cart = [],
  formatCurrency,
  onClose,
  onAddProduct,
}) {
  const filteredProducts = useMemo(() => {
    const query = String(searchValue || "")
      .trim()
      .toLowerCase();

    if (!query) return products;

    return products.filter((product) => {
      const searchableText = [
        product?.name,
        product?.sku,
        product?.barcode,
        product?.brand,
        product?.category,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(query);
    });
  }, [products, searchValue]);

  const isAlreadyAdded = useCallback(
    (product) => {
      return cart?.some(
        (cartItem) =>
          cartItem?.sku && product?.sku && cartItem.sku === product.sku,
      );
    },
    [cart],
  );

  return (
    <div
      className="apoProductModalOverlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className="apoProductModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="apo-product-search-title"
      >
        <div className="apoProductModalHeader">
          <div>
            <span className="apoEyebrow">INVENTORY</span>

            <h2 id="apo-product-search-title">Add items</h2>

            <p>
              Search your inventory and select products for this purchase order.
            </p>
          </div>

          <button
            type="button"
            className="apoIconButton"
            onClick={onClose}
            aria-label="Close product search"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="apoProductSearchBar">
          <SearchIcon />

          <input
            type="search"
            autoFocus
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Search by product name, SKU, barcode or brand..."
          />

          {searchValue && (
            <button
              type="button"
              className="apoProductSearchClear"
              onClick={() => setSearchValue("")}
              aria-label="Clear search"
            >
              <CloseIcon />
            </button>
          )}
        </div>

        <div className="apoProductSearchMeta">
          <span>
            {filteredProducts.length}{" "}
            {filteredProducts.length === 1 ? "product" : "products"}
          </span>

          {searchValue && <span>Results for “{searchValue}”</span>}
        </div>

        <div className="apoProductResults">
          {!products.length ? (
            <div className="apoProductSearchEmpty">
              <div className="apoEmptyIcon">
                <Inventory2OutlinedIcon />
              </div>

              <h3>No inventory items found</h3>

              <p>
                There are currently no products available in your inventory to
                add to this order.
              </p>
            </div>
          ) : !filteredProducts.length ? (
            <div className="apoProductSearchEmpty">
              <div className="apoEmptyIcon">
                <SearchIcon />
              </div>

              <h3>No matching products</h3>

              <p>
                Try searching with a different product name, SKU, barcode or
                brand.
              </p>

              <button
                type="button"
                className="apoSecondaryButton"
                onClick={() => setSearchValue("")}
              >
                Clear search
              </button>
            </div>
          ) : (
            filteredProducts.map((product, index) => {
              const alreadyAdded = isAlreadyAdded(product);

              const inventoryQuantity = Number(
                product?.inventory?.quantity ?? product?.quantity ?? 0,
              );

              const costPrice = Number(
                product?.pricing?.costPrice ??
                  product?.costPrice ??
                  product?.price ??
                  0,
              );

              return (
                <div
                  className={`apoProductResult ${
                    alreadyAdded ? "isAlreadyAdded" : ""
                  }`}
                  key={product?.sku || product?.productId || index}
                >
                  <div className="apoProductResultImage">
                    {product?.image ? (
                      <img
                        src={product.image}
                        alt={product?.name || "Product"}
                      />
                    ) : (
                      <Inventory2OutlinedIcon />
                    )}
                  </div>

                  <div className="apoProductResultInfo">
                    <strong>{product?.name || "Unnamed product"}</strong>

                    <div className="apoProductResultMeta">
                      {product?.sku && <span>SKU: {product.sku}</span>}

                      {product?.barcode && (
                        <>
                          <i />
                          <span>{product.barcode}</span>
                        </>
                      )}
                    </div>

                    {product?.brand && <small>{product.brand}</small>}
                  </div>

                  <div className="apoProductResultStock">
                    <span>Available stock</span>
                    <strong>{inventoryQuantity.toLocaleString("en-NG")}</strong>
                  </div>

                  <div className="apoProductResultPrice">
                    <span>Unit cost</span>
                    <strong>
                      {formatCurrency(costPrice)}
                    </strong>
                  </div>

                  <button
                    type="button"
                    className={
                      alreadyAdded
                        ? "apoProductAddedButton"
                        : "apoProductAddButton"
                    }
                    disabled={alreadyAdded}
                    onClick={() => onAddProduct(product)}
                  >
                    {alreadyAdded ? (
                      <>
                        <CheckCircleIcon />
                        Added
                      </>
                    ) : (
                      <>
                        <AddIcon />
                        Add
                      </>
                    )}
                  </button>
                </div>
              );
            })
          )}
        </div>

        <div className="apoProductModalFooter">
          <span>Select an item to add it to your purchase order.</span>

          <button
            type="button"
            className="apoSecondaryButton"
            onClick={onClose}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
